import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
        width: '30%'
      },
      {
        title: 'Description',
        width: 300,
        dataIndex: 'description',
        width: '50%'
      },
      {
        title: 'Due Date',
        width: 200,
        dataIndex: 'due_date',
        width: '10%'
      },
      {
        title: 'Status',
        dataIndex: 'status',
        width: '10%'
      }
    ]
  }

  getData = violations => {
    return violations.map((item, index) => {
      item.due_date = moment(new Date(item.due_date)).format('YYYY-MM-DD')
      item.key = item.id
      return item
    })
  }

  getJobList = () => {
    const { fullReport } = this.props
    let jobList = []

    fullReport.forEach(item => {
      jobList.push(
        <div key={item.id}>
          <h6 className="steps">{item.job_name}</h6>
          <Table
            pagination={false}
            columns={this.getColumns()}
            dataSource={this.getData(item.violations)}
            size="small"
            style={{ backgroundColor: 'white' }}
          />
        </div>
      )
    })
    return jobList
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Violations</h5>
                  {this.getJobList()}
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/maintenance_dob/violations/ListItem.js